import { Swiper } from 'swiper';
import { Mousewheel, Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import './index.scss';
/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable no-new */

(function () {
  /**
  * initializeBlock
  *
  * Adds custom JavaScript to the block HTML.
  *

  * @since   1.0.0
  *
  * @param   object $block The block jQuery element.
  * @param   object attributes The block attributes (only available when editing).
  * @return  void
  */
  const blockClass = `wp-block-imado-summarize`;
  const blockType = `wp-block-imado-summarize`;

  function initBlock(block) {

  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`.${blockClass}`).forEach((block) => {
      initBlock(block);
    });
  });

  const initializeBlock = function ($block) {
    const block = $block[0].querySelector(`.${blockClass}`);
    if (block) {
      initBlock(block);
    }
  };

  if (window.acf) {
    window.acf.addAction(
      `render_block_preview/type=${blockType}`,
      initializeBlock
    );
  }
})();
